import createPatientAddressFromState from './createPatientAddressFromState.helper';

export default function comparePatientStates(patientStateA, patientStateB) {
  return createPatientAddressFromState(patientStateA) === createPatientAddressFromState(patientStateB);
}
